import React from 'react'
import Container from '../../Container/Container'

import service from '../../../assets/images/icon/service.png'
import service2 from '../../../assets/images/icon/service-02.png'
import service3 from '../../../assets/images/icon/service-03.png'
import service4 from '../../../assets/images/icon/service-04.png'
import service5 from '../../../assets/images/icon/service-05.png'

function Service() {
    return (
        <>
            <Container class1=''>
                    <div className="row">
                        <div className="col-12">
                            <div className="servies d-flex flex-wrap align-items-center justify-content-between ">
                                <div className='col-12 col-sm-6 col-md-4 col-lg-2 p-3 p-lg-0 d-flex align-items-center gap-10'>
                                    <img src={service} alt="service" />
                                    <div>
                                        <h6>حمل و نقل رایگان</h6>
                                        <p>تمام سفارشات بالای 5 ملیون تومان</p>
                                    </div>
                                </div>
                                <div className='col-12 col-sm-6 col-md-4 col-lg-2 p-3 p-lg-0 d-flex align-items-center gap-10'>
                                    <img src={service2} alt="service" />
                                    <div>
                                        <h6>پیشنهادات سورپرایز روزانه</h6>
                                        <p className='mb-0'>تا 25% تخفیف </p>
                                    </div>
                                </div>
                                <div className='col-12 col-sm-6 col-md-4 col-lg-2 p-3 p-lg-0 d-flex align-items-center gap-10'>
                                    <img src={service3} alt="service" />
                                    <div>
                                        <h6>مشاوره مطمئن </h6>
                                        <p className='mb-0'>با کارشناسان فروش</p>
                                    </div>
                                </div>
                                <div className='col-12 col-sm-6 col-md-4 col-lg-2 p-3 p-lg-0 d-flex align-items-center gap-10'>
                                    <img src={service4} alt="service" />
                                    <div>
                                        <h6>بهترین قیمت </h6>
                                        <p className='mb-0'>کمترین قیمت بازار</p>
                                    </div>
                                </div>
                                <div className='col-12 col-sm-6 col-md-4 col-lg-2 p-3 p-lg-0 d-flex align-items-center gap-10'>
                                    <img src={service5} alt="service" />
                                    <div >
                                        <h6>پرداخت های امن</h6>
                                        <p className='mb-0'>پرداخت 100٪ محافظت شده</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </Container>
        </>
    )
}

export default Service